import React from 'react';

import { ReportTableType } from '../types/ReportTableType';

const useFilters = (selectedReportType: ReportTableType) => {
    const [selectedReportFilters, setSelectedReportFilters] = React.useState([]);

    const handleSelectFilters = (filterKey: string) => {
        setSelectedReportFilters((prevSelectedFilters: Record<string, any>[]) => {
            return prevSelectedFilters.map((filter: Record<string, any>) => {
                if (filter.key === filterKey) {
                    return {
                        ...filter,
                        isSelected: !filter.isSelected,
                    };
                }
                return filter;
            });
        });
    };

    React.useEffect(() => {
        let filters = [];
        if (selectedReportType === 'classification-report') {
            filters = [
                {
                    id: 'priced_classifications',
                    key: 'priced_classifications',
                    title: 'Classifications avec prix',
                    isSelected: true,
                },
                {
                    id: 'unpriced_classifications',
                    key: 'unpriced_classifications',
                    title: 'Classifications sans prix',
                    isSelected: true,
                },
                // {
                //     id: 'level_1_classifications_display',
                //     key: 'level_1_classifications_display',
                //     title: 'Classifications de niveau 1',
                //     isSelected: false,
                // },
                // {
                //     id: 'level_2_classifications_display',
                //     key: 'level_2_classifications_display',
                //     title: 'Classifications de niveau 2',
                //     isSelected: false,
                // },
                // {
                //     id: 'level_3_classifications_display',
                //     key: 'level_3_classifications_display',
                //     title: 'Classifications de niveau 3',
                //     isSelected: false,
                // },
            ];
        }

        setSelectedReportFilters(filters);
    }, [selectedReportType]);
    return {
        selectedReportFilters,
        handleSelectFilters,
    };
};

export default useFilters;
